import type { PropsWithChildren } from 'react';

import { UploadButtonStyled } from './styles/UploadButtonStyled'
import { type UploadCommonProps } from '../../Upload'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface IUploadButtonProps {
  commonProps: UploadCommonProps
}

export const UploadButton = ({
  commonProps,
}: PropsWithChildren<IUploadButtonProps>) => {
  const { isDisabled, isUploadDisabled, strings, showFileUpload, uploadProps } =
    commonProps

  const analyticsProps = getAnalyticsDataAttrs(
    uploadProps.analyticsIds?.uploadButton
  )

  return (
    <UploadButtonStyled
      type='button'
      disabled={isDisabled || isUploadDisabled}
      onClick={showFileUpload}
      {...analyticsProps}
    >
      {strings.uploadButtonText}
    </UploadButtonStyled>
  )
}
